var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedotsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 6.93 14.57 C 9.008 14.57 10.307 16.82 9.268 18.62 C 8.786 19.455 7.895 19.97 6.93 19.97 C 4.852 19.97 3.553 17.72 4.592 15.92 C 5.074 15.085 5.965 14.57 6.93 14.57 Z M 6.93 4.04 C 9.008 4.04 10.307 6.29 9.268 8.09 C 8.786 8.925 7.895 9.44 6.93 9.44 C 4.852 9.44 3.553 7.19 4.592 5.39 C 5.074 4.555 5.965 4.04 6.93 4.04 Z M 17.07 14.57 C 19.148 14.57 20.447 16.82 19.408 18.62 C 18.926 19.455 18.035 19.97 17.07 19.97 C 14.992 19.97 13.693 17.72 14.732 15.92 C 15.214 15.085 16.105 14.57 17.07 14.57 Z M 17.07 4.04 C 19.148 4.04 20.447 6.29 19.408 8.09 C 18.926 8.925 18.035 9.44 17.07 9.44 C 14.992 9.44 13.693 7.19 14.732 5.39 C 15.214 4.555 16.105 4.04 17.07 4.04 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotsOn);
export default __webpack_public_path__ + "static/media/threedots_on.523e1c46ab669356e8bf2fbd64068e61.svg";
export { ForwardRef as ReactComponent };